import React, { useContext, useEffect, useState, useMemo } from "react";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogContent, FormControl, FormControlLabel, FormGroup, IconButton, Typography, Fab, List, ListItem, ListItemText, Card, CardContent, InputLabel, MenuItem, Select, TextField, Container, DialogActions, Tabs, Tab, Autocomplete, Divider, Chip } from "@mui/material";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { ArrowBack, Remove, Add, Delete, Discount, ArrowForward } from "@mui/icons-material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import styled from "styled-components";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Cart from "../newCart";
import AddOnProductsScreen from "../addOns";
import OrderForm from "../selectionScreen";
import SelectPartyOlympiad from "../selectPartyOlympiad";
import CartOlympiad from "../newCartOlympiad";
import OrderFormOlympiad from "../selectionScreenOlympiad";
import PaymentScreenOlympiad from "../addOnsOlympiad";
const isMobile = window.innerWidth < 900;
const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 75%;
    height: 100vh;
    max-width: none;
    max-height: none;
  }
`;
const TabContainer = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const AddOlympiadSchoolModal = ({ props, onClose1, onClose, remarks, dataProp, id, distributorId, fetchData, status, editMode, partyS, propType }) => {
  const [activeTab, setActiveTab] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [payload, setPayload] = useState({})
  const [getSeriesCategory, setgetSeriesCategory] = useState()
  const [getSpecimenSeries, setGetSpecimenSeries] = useState([])
  const [cart, setCart] = useState([]);
  const [addOncart, setAddOnCart] = useState([]);
  const [className, setClassName] = useState()
  const [filteredClassName, setFilteredClassName] = useState()
  // const [medium, setMedium] = useState()
  const [partyType, setPartyType] = useState(partyS)
  const [allProducts, setAllProducts] = useState([]);
  const [selectedParty, setSelectedParty] = useState();
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [owner, setOwner] = useState("")
  const [orderMode, setOrderMode] = useState("")
  const [user, setUSer] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [mittplusProducts, setMittplusProducts] = useState([]);
  const [productMittplusList, setProductMittplusList] = useState([]);
  const [specimenSeries, setSpecimenSeries] = useState([]);
  const [specimenClasses, setSpecimenClasses] = useState([]);
  const [specimenProducts, setSpecimenProducts] = useState([]);
  const [specimenFilteredClasses, setSpecimenFilteredClasses] = useState([]);
  const [specimenFilteredProducts, setSpecimenFilteredProducts] = useState([]);
  const [seriesWiseClass, setSeriesWiseClass] = useState([]);
  const [registrationType, setRegistrationType] = useState("");
  const [medium, setMedium] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [classSubjectData, setClassSubjectData] = useState([]);
  const [classSubjectMapping, setClassSubjectMapping] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState({});
  const [olympiadTypes, setOlympiadTypes] = useState([]);
  const [olympiadType, setOlympiadType] = useState("");
  const [productData, setProductData] = useState({
    assignTo: "",
    orderType: propType || "",
    productGroup: "",
    uploadSeries: [],
    series: "",
    class: "",
    medium: "Hindi",
    product: [],
    quantity: "",
    discount: "0",
    orderProcess: "new",
    productType: ""
  });

  const [dropdownData, setDropdownData] = useState({
    classes: [],
    subjects: [],
    mediums: [],
    olympiad_dates: [],
    study_materials: [],
    payment_modes: [],
    registration_type: [],
    Olympiad_type:[]
  });

const selectedOlympiadTypeObj = dropdownData.Olympiad_type.find(
  (t) => t.id === olympiadType
);
const isBothSelected = selectedOlympiadTypeObj?.name === "Both";

const filteredOlympiadDates = useMemo(() => {
  if (!olympiadType || isBothSelected) return dropdownData.olympiad_dates;
  return dropdownData.olympiad_dates.filter(
    (d) => d.olympiad_type === olympiadType
  );
}, [dropdownData.olympiad_dates, olympiadType, isBothSelected]);

const filteredOlympiadClasses = useMemo(() => {
  if (!olympiadType || isBothSelected) return dropdownData.classes;
  return dropdownData.classes.filter(
    (c) => c.olympiad_type === olympiadType
  );
}, [dropdownData.classes, olympiadType, isBothSelected]);

const filteredOlympiadSubjects = useMemo(() => {
  if (!olympiadType || isBothSelected) return dropdownData.subjects;
  return dropdownData.subjects.filter(
    (s) => s.olympiad_type === olympiadType
  );
}, [dropdownData.subjects, olympiadType, isBothSelected]);

// const filteredMediums = useMemo(() => {
//   if (!selectedOlympiadTypeObj) return dropdownData.mediums;

//   if (selectedOlympiadTypeObj.name === "JPQ") {
//     return dropdownData.mediums.filter((m) => m.medium_name === "English");
//   }

//   // MOM or Both -> English + Hindi
//   return dropdownData.mediums;
// }, [dropdownData.mediums, selectedOlympiadTypeObj]);

const filteredMediums = useMemo(() => {
  if (!olympiadType) return dropdownData.mediums;

  if (olympiadType === 2) { // JPQ
    return dropdownData.mediums.filter((m) => m.medium_name === "English");
  }

  // MOM or Both -> English + Hindi
  return dropdownData.mediums;
}, [dropdownData.mediums, olympiadType]);

useEffect(() => {
  if (!editMode) {
    setSelectedClasses([]);
    setSelectedDate("");
    setClassSubjectData([]);
    setSelectedSubjects({});
    setMedium(""); 
  }
}, [olympiadType]);

  useEffect(() => {
    if (!editMode || !dataProp || !dropdownData.classes.length || !classSubjectMapping.length) return;

    const data = dataProp;

    setRegistrationType(Number(data.registration_type));
    setMedium(Number(data.reg_medium));
    setSelectedDate(Number(data.dates_of_olympiad));
    setOlympiadType(Number(data.olympiad_type));

    const classIds = [...new Set(data.lineItems.map(i => Number(i.classId)))];
    setSelectedClasses(classIds);

    const subjectMap = {};
    data.lineItems.forEach(item => {
      const cls = Number(item.classId);
      const subId = Number(item.subjectId);

      if (!subjectMap[cls]) subjectMap[cls] = [];
      subjectMap[cls].push(subId);
    });

    setSelectedSubjects(subjectMap);

    // 3. RIGHT SIDE DATA (IMPORTANT FIX)
    const classSubjectArr = classIds.map(classId => {
      const classObj = dropdownData.classes.find(c => c.id === classId);

      const subjects = data.lineItems
        .filter(i => Number(i.classId) === classId)
        .map(item => ({
          subjectId: Number(item.subjectId),
          subjectName: item.subjectName,
          studentCount: item.student ?? "",
          materialQty: item.study_material ?? ""
        }));

      return {
        classId,
        className: classObj?.class_name,
        subjects
      };
    });

    setClassSubjectData(classSubjectArr);

  }, [editMode, dataProp, dropdownData, classSubjectMapping]);

  const handleClassClick = (cls) => {
    if (selectedClasses.includes(cls)) {
      setSelectedClasses(selectedClasses.filter(c => c !== cls));
    } else {
      setSelectedClasses([...selectedClasses, cls]);
    }
  };

  // const handleSelectAll = (e) => {
  //   if (e.target.checked) {
  //     setSelectedClasses(dropdownData.classes.map(c => c.id));
  //   } else {
  //     setSelectedClasses([]);
  //   }
  // };
  const handleSelectAll = (e) => {
  if (e.target.checked) {
    setSelectedClasses(filteredOlympiadClasses.map((c) => c.id));
  } else {
    setSelectedClasses([]);
  }
};

  useEffect(() => {
    setCart([]);
    setAddOnCart([]);
    setFilteredProducts([]);
    setSpecimenFilteredClasses([]);
    setSpecimenFilteredProducts([]);
    setFilteredClassName([]);

    setProductData((prev) => ({
      ...prev,
      uploadSeries:
        editMode && prev.orderProcess === "upload"
          ? prev.uploadSeries
          : [],
      series: "",
      class: "",
      product: [],
      quantity: "",
      productType: "",
    }));
  }, [productData.orderType, editMode, productData?.orderProcess]);

  const getAvailableQty = (product) => {
    if (!product) return 0;
    const keys = ['quantity', 'qty', 'availableQuantity', 'available', 'stock', 'inHand', 'available_qty', 'in_stock', 'totalQuantity'];
    for (const k of keys) {
      if (product[k] !== undefined && product[k] !== null) return Number(product[k]);
    }
    return 0;
  };

  const handleQuantityChange = (index, delta) => {
    let temp = [...cart];
    const current = temp[index] || {};
    const newQty = Math.max(1, current.quantity + delta);

    if (productData.orderType === 'Specimen') {
      const available = getAvailableQty(current.data);
      if (newQty > available) {
        window.NotificationUtils.showError('You Do Not Have Enough Stock');
        return;
      }
    }

    temp[index].quantity = newQty;
    setCart(temp);
  };

  const handleRemoveItem = (index) => {


    let temp = [...cart]
    temp.splice(index, 1)
    setCart(temp)
  };

  function closePopup() {
    fetchData()
    onClose1()
  }

  useEffect(() => {
    getOlympiadDropdownData()
    getAllClassSubjectMappings();
  }, [])

  const getAllClassSubjectMappings = async () => {
    let res = await window.Platform.database.getAllClassSubjectMappings();
    if (res?.status) {
      setClassSubjectMapping(res.data);
    }
  };

  useEffect(() => {
    getSpecimenProduct();
    getProductSpecimenInventory();
  }, [owner])

  useEffect(() => {
    if (editMode && productData?.orderType == "Specimen") {
      getProductSpecimenInventory();
    }
  }, [productData?.orderProcess,])

  useEffect(() => {
    filterProducts();
  }, [productData.series, productData.class, productData.medium, allProducts]);

  useEffect(() => {
    if (productData.orderType === "Specimen") {
      filterSpecimenProducts();
    }
  }, [productData.series, productData.class]);
  useEffect(() => {
    if (!editMode || cart.length === 0) return;

    const uniqueSeriesClass = [];

    cart.forEach((item) => {
      const series = item?.data?.seriesCategory;
      const classId = item?.data?.classId || item?.class;
      const medium = item?.data?.mediumTableId;

      if (!series || !classId) return;

      const exists = uniqueSeriesClass.some(
        (x) =>
          x.series === series &&
          x.class === classId &&
          x.medium === medium
      );

      if (!exists) {
        uniqueSeriesClass.push({
          series,
          class: classId,
          medium,
          productGroup: item?.group,
          orderType: item?.orderType,
        });
      }
    });

    setSeriesWiseClass(uniqueSeriesClass);
  }, [cart, editMode]);

  const getProductSpecimenInventory = async () => {
    try {
      const t = localStorage.getItem("user");
      const id = t ? JSON.parse(t).id : "";
      const body = { user_id: editMode ? dataProp?.ownerId : owner };
      let response = await window.Platform.database.getProductWithSeries(body);
      if (response) {
        let b = [];
        let c = [];
        let d = [];
        for (let i = 0; i < response.data.length; i++) {
          const item = response.data[i];
          const seriesItem = {
            seriesTableId: item.seriesCategory,
            seriesName: item.seriesName
          };
          if (!b.some((x) => x.seriesTableId === seriesItem.seriesTableId)) {
            b.push(seriesItem);
          }
          const classItem = {
            classId: item.classId,
            className: item.className
          };
          if (!c.some((x) => x.classId === classItem.classId)) {
            c.push(classItem);
          }
        }
        setSpecimenSeries(b);
        setSpecimenClasses(c);
        setSpecimenProducts(response.data);
      } else {
        throw new Error("Failed to load orders");
      }
    } catch (error) {
      console.log("Error fetching orders:", error);
    } finally {
    }
  };

  const getAvailableProducts = () => {
    if (productData.orderType === "Specimen") return specimenFilteredProducts;

    if (productData.productGroup === "6HPipXSLx5") {
      const list = productMittplusList.filter((p) => {
        if (!productData.productType) return true;
        return p.productType === productData.productType;
      });
      return list.map((p) => ({
        skuId: p.id,
        nameSku: p.product_name,
        unitPrice: p.landing_cost || 0,
        original: p
      }));
    }
    return filteredProducts;
  };

  const getSpecimenProduct = async () => {
    try {
      let results = await window.Platform.database.getSpecimenProduct();

      if (results && results.status) {
        // setSpecimenProduct(results.data)
      }
    } catch (error) {
      console.error("ERRORCHECK", error);
    }
  }

  const getSeriesCategoryData = async (data) => {
    let results = await window.Platform.database.getSeriesCategory();
    setgetSeriesCategory(results.data);
  }

  const getOlympiadDropdownData = async () => {
    let results = await window.Platform.database.getOlympiadDropdownData();

    if (results?.status) {
      setDropdownData(results.data);
    }
  };

  const filterProducts = () => {
    const filtered = allProducts.filter((product) => {
      const matchesSeries =
        product.seriesCategory === productData.series;
      const matchesClass =
        !productData.class || product.classId === productData.class;
      const matchesMedium =
        !productData.medium || product.mediumTableId === productData.medium;

      return matchesSeries && matchesClass && matchesMedium;
    });
    setFilteredProducts(filtered);
  };

  const handleAddProductToCart = (productData) => {
    if (!productData.class) {
      alert("Please Select Class");
      return;
    }
    const productsToSearch = getAvailableProducts();

    if (!productData.product?.length || !productData.quantity) {
      window.NotificationUtils.showError("Please select product(s) and quantity");
      return;
    }

    let temp = [...cart];
    const requestedQty = parseInt(productData.quantity, 10);

    const seriesWiseClassData = {
      series: productData.series,
      class: productData.class,
      medium: productData.medium,
      productGroup: productData.productGroup,
      orderType: productData.orderType
    };

    const classExists = seriesWiseClass.some(
      item => item.series === productData.series && item.class === productData.class && item.medium === productData.medium
    );

    if (!classExists && productData.series && productData.class) {
      setSeriesWiseClass([...seriesWiseClass, seriesWiseClassData]);
    }

    productData.product.forEach((skuId) => {
      const selectedProduct = productsToSearch.find(
        (product) => product.skuId === skuId
      );
      if (!selectedProduct) return;

      let index = temp.findIndex(
        (item) => item.data.skuId === selectedProduct.skuId
      );

      const existingQty = index > -1 ? temp[index].quantity : 0;

      // ✅ specimen stock check
      if (productData.orderType === "Specimen") {
        const available = getAvailableQty(selectedProduct);
        if (available === 0) {
          window.NotificationUtils.showError(
            `${selectedProduct.nameSku}Product has no available stock`
          );
          return;
        }
        if (existingQty + requestedQty > available) {
          window.NotificationUtils.showError(
            `Not enough stock for ${selectedProduct.nameSku}`
          );
          return;
        }
      }

      if (index > -1) {
        temp[index].quantity += requestedQty;
      } else {
        temp.push({
          data: selectedProduct,
          group: productData.productGroup,
          quantity: requestedQty,
          bookType:
            selectedProduct && selectedProduct?.type?.toLowerCase() === "set"
              ? "Choose from Set"
              : "Choose from Individual Book",
          orderType: productData.orderType || "",
          class: productData.class || ""
        });
      }
    });

    setCart(temp);

    // ✅ RESET MUST BE ARRAY
    setProductData({
      ...productData,
      product: [],
      quantity: "",
    });

    window.NotificationUtils.showSuccess("Product(s) added successfully");
  };

  function proceedToAddOns(value, body) {
    if (body?.orderType === "Specimen") {
      setPayload(body);
      setAddOnCart([]); // Clear add-on items for Specimen
      setActiveTab(4); // Jump directly to order form
    } else {
      setPayload(body)
      setAddOnCart(value)
      setActiveTab(3) // Show add-ons screen for non-Specimen orders
    }
  }
  function proceedToOrderForm(value) {
    setPayload(value)
    setActiveTab(4)
  }

  function sortClasses(value) {
    if (productData.orderType === "Specimen") {
      const classesInSeries = specimenProducts
        .filter((product) => product.seriesCategory === value)
        .map((product) => product.classId);
      const uniqueClasses = specimenClasses.filter((cls) =>
        classesInSeries.includes(cls.classId)
      );
      setSpecimenFilteredClasses(uniqueClasses);
    } else {
      let pro = allProducts.filter((ele) => { return ele.seriesCategory == value }).map((ele) => ele.classId)
      setFilteredClassName(className.filter((ele) => { return pro.includes(ele.classId) }))
    }
  }

  function filterSpecimenProducts() {
    if (productData.series && productData.class) {
      const filtered = specimenProducts.filter((product) =>
        product.seriesCategory === productData.series &&
        product.classId === productData.class
      );
      setSpecimenFilteredProducts(filtered);
    } else {
      setSpecimenFilteredProducts([]);
    }
  }
  function proceedToCart() {
    // ✅ Validation
    if (!registrationType || !medium || !selectedDate || selectedClasses.length === 0) {
      window.NotificationUtils.showError("Please fill all Olympiad details");
      return;
    }

    // let hasValidEntry = false;

    // // ✅ Loop through data
    // for (const cls of classSubjectData) {
    //   for (const sub of cls.subjects) {

    //     const studentValid = showStudentCount
    //       ? Number(sub.studentCount) > 0
    //       : true;

    //     const materialValid = showMaterialCount
    //       ? Number(sub.materialQty) > 0
    //       : true;

    //     if (studentValid && materialValid) {
    //       hasValidEntry = true;
    //       break;
    //     }
    //   }
    //   if (hasValidEntry) break;
    // }

let hasStudentEntry = false;
let hasMaterialEntry = false;

for (const cls of classSubjectData) {
  for (const sub of cls.subjects) {
    if (Number(sub.studentCount) > 0) hasStudentEntry = true;
    if (Number(sub.materialQty) > 0) hasMaterialEntry = true;
  }
}

const studentValid = showStudentCount ? hasStudentEntry : true;
const materialValid = showMaterialCount ? hasMaterialEntry : true;

const hasValidEntry = studentValid && materialValid;

    // ❌ Dynamic error message
    if (!hasValidEntry) {
      let message = "";

      if (showStudentCount && showMaterialCount) {
        message = "Please enter at least one subject with Student Count and Study Material";
      } else if (showStudentCount) {
        message = "Please enter at least one subject with Student Count";
      } else if (showMaterialCount) {
        message = "Please enter at least one subject with Study Material";
      }

      window.NotificationUtils.showError(message);
      return;
    }

    const selectedRegTypeObj = dropdownData.registration_type.find(r => r.id === registrationType);
    const selectedMediumObj = dropdownData.mediums.find(m => m.id === medium);
    const selectedDateObj = dropdownData.olympiad_dates.find(d => d.id === selectedDate);
    const selectedOlympiadType = dropdownData.Olympiad_type.find(d => d.id === olympiadType);

    const selectedClassObjs = dropdownData.classes.filter(c =>
      selectedClasses.includes(c.id)
    );

    let obj = {
      address: selectedParty?.AddressLine1,
      addressId: selectedParty?.addressId,
      approvalStatus: "1",
      discount: "0",
      email: selectedParty?.email,
      mobileNo: selectedParty?.makerContact,
      orderType: productData.orderType,
      partyId: selectedParty?.schoolId || selectedParty?.distributorID,
      // partyType: partyType?.toLowerCase() == 'distributor' ? "P6E9TGXewd" : "cQpLw8vwZf",
      partyType: "cQpLw8vwZf",
      totalAmount: 0,
      transport: selectedParty?.transporterId,
      ownerId: owner,
      orderMode: orderMode,
      orderProcess: productData?.orderProcess,

      olympiadDetails: {
        olympiadTypeId: olympiadType,
        olympiadTypeName: selectedOlympiadTypeObj?.name,
        registrationTypeId: registrationType,
        registrationTypeName: selectedRegTypeObj?.name,

        mediumId: medium,
        mediumName: selectedMediumObj?.medium_name,

        olympiadDateId: selectedDate,
        examDate: selectedDateObj?.exam_date,
        lastRegistrationDate: selectedDateObj?.last_registration_date,
        registrationFee: selectedDateObj?.registration_fee,

        classes: selectedClassObjs.map(c => ({
          id: c.id,
          name: c.class_name
        })),
        classSubjects: classSubjectData,
      },
      paymentModes: dropdownData.payment_modes
    };

    setPayload(obj);
    setActiveTab(2);
  }
  function back() {
    setActiveTab(activeTab - 1)
  }
  console.log(payload, "payload kanskbaskjbkas")
  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });
  };

  const handleAddClasses = () => {
    if (!registrationType) {
      window.NotificationUtils.showError("Please select Registration Type");
      return;
    }

    if (!medium) {
      window.NotificationUtils.showError("Please select Olympiad Medium");
      return;
    }

    if (!selectedDate) {
      window.NotificationUtils.showError("Please select Olympiad Date");
      return;
    }

    if (!selectedClasses.length) {
      window.NotificationUtils.showError("Please select at least one class");
      return;
    }

    // 🔥 Step 1: sort classes properly
    const sortedClassIds = [...selectedClasses].sort((a, b) => {
      const classA = dropdownData.classes.find(c => c.id === a)?.class_name || "";
      const classB = dropdownData.classes.find(c => c.id === b)?.class_name || "";

      const numA = parseInt(classA.replace(/\D/g, ""));
      const numB = parseInt(classB.replace(/\D/g, ""));

      return numA - numB;
    });

    const newData = sortedClassIds.map((classId) => {
      const classObj = dropdownData.classes.find(c => c.id === classId);

      return {
        classId,
        className: classObj?.class_name,
        subjects: getSubjectsForClass(classObj?.class_name)
      };
    });

    setClassSubjectData(newData);
  };

  useEffect(() => {
    if (!isStudyMaterialAllowed) {
      setClassSubjectData(prev =>
        prev.map(cls => ({
          ...cls,
          subjects: cls.subjects.map(sub => ({
            ...sub,
            materialQty: ""
          }))
        }))
      );
    }
  }, [medium]);

useEffect(() => {
  if (olympiadType === 2) { // JPQ
    const englishMedium = dropdownData.mediums.find((m) => m.medium_name === "English");
    if (englishMedium) setMedium(englishMedium.id);
  }
}, [olympiadType, dropdownData.mediums]);

  // const getSubjectsForClass = (className) => {
  //   return classSubjectMapping
  //     .filter(item => item.class_name === className)
  //     .map((item, index) => ({
  //       subjectId: `${className}-${item.subject_name}-${index}`, // ✅ unique id
  //       subjectName: item.subject_name,
  //       studentCount: "",
  //       materialQty: ""
  //     }));
  // };
  const getSubjectsForClass = (className) => {
    console.log(classSubjectMapping, "classSubjectMappingclassSubjectMapping", className)
    return classSubjectMapping
      .filter(item => item.class_name === className)
      .map((item) => ({
        subjectId: item.subject_id || item.subject_name,
        subjectName: item.subject_name,
        studentCount: "",
        materialQty: ""
      }));
  };

  const handleSubjectChange = (classId, subjectId, field, value) => {
    setClassSubjectData(prev =>
      prev.map(cls => {
        if (cls.classId !== classId) return cls;

        return {
          ...cls,
          subjects: cls.subjects.map(sub =>
            sub.subjectId === subjectId
              ? { ...sub, [field]: value }
              : sub
          )
        };
      })
    );
  };

  const groupBySubject = () => {
    const subjectMap = {};

    classSubjectData.forEach((cls) => {
      cls.subjects.forEach((sub) => {
        if (!subjectMap[sub.subjectName]) {
          subjectMap[sub.subjectName] = [];
        }

        subjectMap[sub.subjectName].push({
          classId: cls.classId,
          className: cls.className,
          subjectId: sub.subjectId,
          studentCount: sub.studentCount,
          materialQty: sub.materialQty
        });
      });
    });

    return Object.entries(subjectMap).map(([subjectName, classes]) => ({
      subjectName,
      classes
    }));
  };


  const regType = Number(registrationType);

  const showStudentCount = regType === 1 || regType === 2; // 1 & 2
  // const showMaterialCount = regType === 1 || regType === 3; // 1 & 3

  const selectedMediumObj = dropdownData.mediums.find(
    (m) => m.id === medium
  );

  const isStudyMaterialAllowed = selectedMediumObj?.isStudyMaterial === "yes";

  const showMaterialCount = (regType === 1 || regType === 3) && isStudyMaterialAllowed;


  const subjectWiseData = groupBySubject();

  useEffect(() => {
    if (!editMode) {

      if (!registrationType) return;

      // reset right side data completely
      setClassSubjectData([]);
      setSelectedClasses([]);
      setSelectedDate("");
      setMedium("");
      setClassSubjectData([]);
      setSeriesWiseClass([]);

      setProductData((prev) => ({
        ...prev,
        uploadSeries: [],
        series: "",
        class: "",
        product: [],
        quantity: "",
        productType: ""
      }));

      setPayload({}); // 🔥 IMPORTANT: clear old payload
    }
  }, [registrationType]);

  const getSubjectsBySelectedClasses = () => {
    const map = {};

    selectedClasses.forEach((classId) => {
      const classObj = dropdownData.classes.find(c => c.id === classId);
      const subjects = classSubjectMapping
        .filter(item => item.class_name === classObj?.class_name)
        .map(item => ({
          subjectId: item.subject_id || item.subject_name,
          subjectName: item.subject_name
        }));

      map[classId] = subjects;
    });

    return map;
  };

  const handleSubjectToggle = (classId, subject) => {
    console.log(classId, subject, "kbdaskjbasdasdb")
    setSelectedSubjects((prev) => {
      const prevSubjects = prev[classId] || [];

      let updated;
      if (prevSubjects.includes(subject.subjectId)) {
        updated = prevSubjects.filter(id => id !== subject.subjectId);
      } else {
        updated = [...prevSubjects, subject.subjectId];
      }

      return {
        ...prev,
        [classId]: updated
      };
    });
  };

  // useEffect(() => {
  //   const newData = selectedClasses.map((classId) => {
  //     const classObj = dropdownData.classes.find(c => c.id === classId);

  //     const subjects = getSubjectsForClass(classObj?.class_name)
  //       .filter(sub =>
  //         selectedSubjects[classId]?.includes(sub.subjectId)
  //       );

  //     return {
  //       classId,
  //       className: classObj?.class_name,
  //       subjects: subjects.map(sub => ({
  //         ...sub,
  //         studentCount: "",
  //         materialQty: ""
  //       }))
  //     };
  //   }).filter(cls => cls.subjects.length > 0); // remove empty

  //   setClassSubjectData(newData);
  // }, [selectedSubjects, selectedClasses]);

  useEffect(() => {
    // if (editMode) return;

    setClassSubjectData((prev) => {

      // 🔹 Step 1: Keep only selected classes
      let updated = prev.filter(cls =>
        selectedClasses.includes(cls.classId)
      );

      // 🔹 Step 2: Loop selected classes
      const finalData = selectedClasses.map((classId) => {
        const classObj = dropdownData.classes.find(c => c.id === classId);
        const selectedSubIds = selectedSubjects[classId] || [];

        const allSubjects = getSubjectsForClass(classObj?.class_name);

        const filteredSubjects = allSubjects.filter(sub =>
          selectedSubIds.includes(sub.subjectId)
        );

        const existingClass = updated.find(c => c.classId === classId);

        return {
          classId,
          className: classObj?.class_name,

          subjects: filteredSubjects.map(sub => {
            const old = existingClass?.subjects?.find(
              s => s.subjectId === sub.subjectId
            );

            return old
              ? { ...old } // ✅ clone (IMPORTANT)
              : {
                ...sub,
                studentCount: "",
                materialQty: ""
              };
          })
        };
      });

      return finalData; // ✅ ALWAYS NEW ARRAY
    });

  }, [selectedSubjects, selectedClasses]);
  useEffect(() => {
    setSelectedSubjects((prev) => {
      const updated = {};
      selectedClasses.forEach((cls) => {
        if (prev[cls]) updated[cls] = prev[cls];
      });
      return updated;
    });
  }, [selectedClasses]);

  return (
    <StyledDialog open={true} style={{ width: "106vw" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6">Olympiad Registration</Typography>
        <IconButton onClick={onClose}>
          <CloseOutlined />
        </IconButton>
      </Box>
      <Tabs value={activeTab} onChange={(e, newTab) => setActiveTab(newTab)}>
        <Tab label="Select Party" style={{ width: "20%" }} disabled />
        <Tab label="Registration Form" style={{ width: "20%" }} disabled />
        <Tab label="Review" style={{ width: "20%" }} disabled />
        <Tab label="Cordinator Details" style={{ width: "20%" }} disabled />
        <Tab label="Payment Details" style={{ width: "20%" }} disabled />
      </Tabs>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 1, ml: 2 }}>
        {activeTab > 0 && (
          <Button variant="outlined" onClick={() => setActiveTab((prev) => Math.max(0, prev - 1))}>
            <ArrowBackIcon sx={{ marginRight: "2px" }} />  Back
          </Button>
        )}
      </Box>
      {activeTab === 0 && (
        <>
          <SelectPartyOlympiad editMode={editMode} back={back} partyId={dataProp ? dataProp.partyId : ""} regId={dataProp ? dataProp.regId : ""} ownerId={dataProp ? dataProp.ownerId : ""} chooseParty={setSelectedParty} choosePartyType={setPartyType} setTab={setActiveTab} partyType={partyType} setOwner={setOwner} setParentOrderMode={setOrderMode} />
        </>
      )}
      {activeTab === 1 && (
        <div style={{ display: "flex", width: "100%", gap: "20px" }}>
          <div style={{ flex: 1, maxWidth: "50%" }}>
            <TabContainer style={{ width: "100%" }}>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Select Olympiad Type</InputLabel>
                <Select
                  value={olympiadType}
                  disabled={editMode}
                  label="Select Olympiad Type"
                  onChange={(e) => setOlympiadType(e.target.value)}
                >
                  {dropdownData.Olympiad_type.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Registration Type</InputLabel>
                <Select
                  value={registrationType}
                  // disabled={editMode}
                  label="Registration Type"
                  onChange={(e) => setRegistrationType(e.target.value)}
                >
                  {dropdownData.registration_type.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl fullWidth sx={{ mb: 2 }}>
                <InputLabel>Olympiad Medium</InputLabel>
                <Select
                  value={medium}
                  // disabled={editMode}
                  label="Olympiad Medium"
                  onChange={(e) => setMedium(e.target.value)}
                >
                  {filteredMediums.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.medium_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Typography mb={1}>Date of Olympiad</Typography>
              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                {filteredOlympiadDates.map((item) => (
                  <Chip
                    key={item.id}
                    label={formatDate(item.exam_date)}
                    clickable
                    color={selectedDate === item.id ? "primary" : "default"}
                    onClick={() => setSelectedDate(item.id)}
                  />
                ))}
              </Box>
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography>{editMode ? "Selected" : "Select"} Classes</Typography>
                <Box display="flex" alignItems="center">
                  <Checkbox
                    checked={
                      selectedClasses.length === filteredOlympiadClasses.length &&
                      filteredOlympiadClasses.length > 0
                    }
                    onChange={handleSelectAll}
                  />
                  {!editMode && <Typography>Select All</Typography>}
                </Box>
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                {filteredOlympiadClasses.map((cls) => (
                  <Chip
                    key={cls.id}
                    label={cls.class_name}
                    clickable
                    color={selectedClasses.includes(cls.id) ? "primary" : "default"}
                    onClick={() => handleClassClick(cls.id)}
                  />
                ))}
              </Box>
              {selectedClasses.length > 0 && (
                <Box mt={2}>
                  <Typography variant="subtitle1">Select Subjects</Typography>
                  {console.log(selectedClasses, "<<<<<<<<<<<<<<<<selectedClasses",)}
                  {selectedClasses.map((classId) => {
                    const classObj = dropdownData.classes.find(c => c.id === classId);
                    const subjects = getSubjectsForClass(classObj?.class_name);
                    { console.log(classObj, "<<<<<<<<<<<classessss", subjects, "<Objedtcs") }
                    return (
                      <Box key={classId} mt={2}>
                        <Typography fontWeight={600}>{classObj?.class_name}</Typography>

                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                          {subjects.map((sub) => {
                            const isSelected =
                              selectedSubjects[classId]?.includes(sub.subjectId);

                            return (
                              <Chip
                                key={sub.subjectId}
                                label={sub.subjectName}
                                clickable
                                color={isSelected ? "primary" : "default"}
                                onClick={() => handleSubjectToggle(classId, sub)}
                              />
                            );
                          })}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              )}
              {/* <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, bgcolor: "#ff6b3d" }}
                onClick={() => proceedToCart()}
              >
                Proceed
              </Button> */}
              {/* <Button
                fullWidth
                variant="contained"
                sx={{ mt: 3, bgcolor: "#ff6b3d" }}
                onClick={handleAddClasses}
              >
                Add
              </Button> */}
            </TabContainer>
          </div>

          <div style={{ flex: 1, maxWidth: "60%" }}>
            {/* {classSubjectData.map((cls) => (
              <Card key={cls.classId} sx={{ mb: 2, p: 2 }}>
                <Typography variant="h6">{cls.className}</Typography>

                {cls.subjects.map((sub, i) => (
                  <Box key={sub.subjectId} sx={{ display: "flex", gap: 2, mt: 2 }}>

                    <Typography sx={{ width: "150px" }}>
                      {sub.subjectName}
                    </Typography>

                    <TextField
                      label="Students"
                      type="number"
                      size="small"
                      value={sub.studentCount}
                      onChange={(e) =>
                        handleSubjectChange(cls.classId, sub.subjectId, "studentCount", e.target.value)
                      }
                    />

                    <TextField
                      label="Material Qty"
                      type="number"
                      size="small"
                      value={sub.materialQty}
                      onChange={(e) =>
                        handleSubjectChange(cls.classId, sub.subjectId, "materialQty", e.target.value)
                      }
                    />
                  </Box>
                ))}
              </Card>
            ))} */}


            {subjectWiseData.map((subject) => (
              <Card key={subject.subjectName} sx={{ mb: 3, p: 2, borderRadius: 3 }}>

                {/* 🔵 Subject Header */}
                <Box sx={{ bgcolor: "#4444df5d", color: "#fff", p: 2, borderRadius: 2 }}>
                  <Typography variant="h6">{subject.subjectName}</Typography>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2, px: 1 }}>
                  <Typography sx={{ width: "30%" }}>Class Name</Typography>

                  {showStudentCount && (
                    <Typography sx={{ width: "30%" }}>Student Count</Typography>
                  )}

                  {showMaterialCount && (
                    <Typography sx={{ width: "30%" }}>Study Material Count</Typography>
                  )}
                </Box>

                {/* 🔹 Class Rows */}
                {subject.classes.map((cls) => (
                  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mt: 2 }}>

                    <Typography sx={{ width: "30%" }}>
                      {cls.className}
                    </Typography>

                    {showStudentCount && (
                      <TextField
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        size="small"
                        sx={{ width: "30%" }}
                        value={cls.studentCount}
                        onChange={(e) =>
                          handleSubjectChange(
                            cls.classId,
                            cls.subjectId,
                            "studentCount",
                            e.target.value
                          )
                        }
                      />
                    )}

                    {showMaterialCount && (
                      <TextField
                        type="number"
                        onWheel={(e) => e.target.blur()}
                        size="small"
                        sx={{ width: "30%" }}
                        value={cls.materialQty}
                        onChange={(e) =>
                          handleSubjectChange(
                            cls.classId,
                            cls.subjectId,
                            "materialQty",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Box>
                ))}
              </Card>
            ))}
            {classSubjectData.length > 0 && (
              <Button
                variant="contained"
                color="success"
                fullWidth
                sx={{ mt: 2 }}
                onClick={proceedToCart}
              >
                Proceed
              </Button>)}
          </div>
        </div>
      )}

      {activeTab === 2 && (
        <>
          <CartOlympiad payload={payload} editMode={editMode} seriesD={dataProp ? dataProp?.seriesDiscount : ""} attachments1={dataProp ? dataProp?.attachment : []} series={getSeriesCategory} initialCartItems={cart} setCart={setCart} proceed={proceedToAddOns} newDataProp={productData} tntAmount={dataProp ? dataProp?.tentativeAmount : null} isSpecimen={productData?.orderType === "Specimen"}  subjects={filteredOlympiadSubjects || []} />
        </>
      )}

      {activeTab === 3 && productData?.orderType !== "Specimen" && (
        <PaymentScreenOlympiad editMode={editMode} dataPropCoordinators={editMode ? dataProp?.coordinators : {}} payload={payload} items={addOncart} series={getSeriesCategory} proceed={proceedToOrderForm} seriesWiseClass={seriesWiseClass} />
      )}
      {console.log(dataProp, "dataPropaDSASDASDS")}
      {activeTab === 4 && (
        <OrderFormOlympiad payload={payload} closePopup={closePopup} editData={dataProp ? dataProp : null} editMode={editMode} getSeriesCategory={getSeriesCategory} />
      )}
    </StyledDialog>
  );
};

export default AddOlympiadSchoolModal;